// Product Colors
// Cheddar
const colors = {
  CHEDDAR: ['', '#fef3e9', '#fedbbd', '#fec491', '#fead64', '#ff993f', '#f58525', '#eb710b', '#e06107', '#ca500f', '#b0430c'],
  OCEAN: ['', '#eaf7fc', '#b0e3f4', '#75cfec', '#3bbbe3', '#00a7db', '#0093C4', '#007fad', '#006c94', '#005a75', '#00465c'],
  MAGIC: ['', '#f2f4f9', '#D2D9ED', '#B2BEE0', '#91A3D4', '#7188C7', '#516DBB', '#425ba1', '#334a88', '#24386e', '#002244'],
  SANGRIA: ['', '#fdf2f5', '#fbcada', '#f8a2bf', '#f57aa3', '#f35288', '#e53872', '#d81e5d', '#bf1b52', '#a61747', '#8c143c'],
  JUNGLE: ['', '#e8f7f2', '#c0eadb', '#86e0c2', '#55d5a9', '#24c991', '#1fb380', '#1a9c6e', '#16825c', '#12694a', '#0d4f38'],
  PICKLE: ['', '#f4f6ea', '#e0eab8', '#ccde87', '#b7d155', '#a3c523', '#91b215', '#7e9e06', '#698505', '#556b04', '#415203'],
  BRICK: ['', '#FAE6E3', '#FAC3BB', '#FAA094', '#FA7D6D', '#F75F4B', '#EB4F3B', '#D24634', '#B83E2E', '#9E3528', '#852D21'],
  MIST: ['', '#E6F4F7', '#C9E5EA', '#ACD5DD', '#8FC6CF', '#6EADBA', '#5F96A1', '#4F7E87', '#41666E', '#324E54', '#23373B'],
  EGGPLANT: ['', '#F6F1F9', '#DDCBE9', '#C4A4D9', '#AB7EC9', '#9258B9', '#7A4C98', '#684182', '#543469', '#3F284F', '#2B1B36'],
  CLOUD: ['', '#fafafa', '#f6f6f6', '#ececec', '#dadada', '#b3b3b3', '#949494', '#757575', '#646464', '#525252', '#3c3c3c'],
  NINJA: ['', '#f1f1fa', '#e3e3f0', '#d5d5e2', '#cacad9', '#bbbbcc', '#9e9ead', '#7c7c89', '#595963', '#40404c', '#2f2f39', '#1b1b26'],
  CHERRY: ['', '#f54250', '#cc313d'],
  GRASS: ['', '#21a921', '#0a870a']
};

export default colors;
